import React from 'react'

import {Form} from './Form'
import {Header} from './Header'
import {usePoll} from './Poll.hooks'
import {PollProps as Props} from './Poll.types'
import {Question} from './Question'

function PollBase({poll}: Props): React.ReactElement<Props> {
  const {handleAnswerClick, isPollCompleted, questions} = usePoll(poll)
  return (
    <>
      <Header header={poll.header} isPollCompleted={isPollCompleted} />
      {questions.map(question => (
        <Question key={question.id} handleAnswerClick={handleAnswerClick} question={question} />
      ))}
    </>
  )
}

export default function Poll({poll}: Props): React.ReactElement<Props> {
  return (
    <Form poll={poll}>
      <PollBase poll={poll} />
    </Form>
  )
}
